import React from "react";
import { motion } from "framer-motion";
import { AlertTriangle, ExternalLink, ShieldAlert } from "lucide-react";
import fraud from "../assets/Img/FraudImage.webp";

const fraudAlerts = [
  { Name: "List of Unregistered Agencies against which Grievances Received", link: "https://emigrate.gov.in/#/emigrate/recruiting-agent/list-of-unregistered-ra-agencies-or-agents" },
  { Name: "Advisory for Indian Nationals – Fake Job Offers in Thailand", link: "https://emigrate.gov.in/assets/pdfs/staticdocuments/fra/Advisory%20for%20Indian%20Nationals_Fake%20Job%20Offers%20in%20Thailand.jpg" },
  { Name: "Advisory regarding fake job racket targeting Indian youth", link: "https://emigrate.gov.in/assets/pdfs/staticdocuments/fra/Advisory%20May24.pdf" },
  { Name: "Advisory for Indian Nationals travelling to Laos & Cambodia", link: "https://emigrate.gov.in/assets/pdfs/staticdocuments/fra/Advisory%20for%20Indian%20Nationals%20travelling%20to%20Laos%20&%20Cambodia.jpg" },
  { Name: "Advisory for Indian Nationals – Fake Job Offers in Laos", link: "https://emigrate.gov.in/assets/pdfs/staticdocuments/fra/Advisory%20for%20Indian%20Nationals_Fake%20Job%20Offers%20in%20Laos.jpg" },
  { Name: "Advisory regarding fake job offers in the Netherlands", link: "https://emigrate.gov.in/assets/pdfs/staticdocuments/fra/Fake%20jobs%20Advisory%20-%20Netherlands.pdf" },
  { Name: "नीदरलैंड में फर्जी नौकरी प्रदान करने के संदर्भ में जारी परामर्श", link: "https://emigrate.gov.in/assets/pdfs/staticdocuments/fra/Fake%20jobs%20Advisory%20-%20Netherlands%20(Hindi).pdf" },
  { Name: "Advisory for job seekers in Cambodia and SEA about fake jobs involving cyber crimes", link: "http://emigrate.gov.in/assets/pdfs/staticdocuments/fra/Fraud%20alert%20-%20Phnom%20Penh.pdf" },
];

function FraudAlerts() {
  return (
    // Outer container: centers the component on large screens
    <div className="w-full flex justify-center px-4 sm:px-6">
      <div className="w-full max-w-7xl bg-white rounded-3xl border border-slate-100 shadow-sm overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-red-600 to-rose-500 px-4 sm:px-6 py-3 sm:py-4 flex items-center gap-3">
          <ShieldAlert size={22} className="text-white shrink-0" />
          <div>
            <h2 className="text-white font-bold text-lg sm:text-xl lg:text-2xl leading-tight">
              Fraud Alerts
            </h2>
            <p className="text-red-100 text-xs sm:text-sm">
              Official MEA advisories — stay protected
            </p>
          </div>
        </div>

        {/* Responsive Grid – improves balance on large screens */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
          {/* Alert list */}
          <div className="p-5 sm:p-6 lg:p-8">
            <div className="space-y-3 max-h-80 lg:max-h-96 overflow-y-auto pr-2">
              {fraudAlerts.map((alert, i) => (
                <motion.a
                  key={i}
                  href={alert.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  initial={{ opacity: 0, x: -12 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.04, duration: 0.3 }}
                  className="flex items-start gap-3 p-3 rounded-xl hover:bg-red-50 border border-transparent hover:border-red-100 transition-all duration-200 group"
                >
                  <AlertTriangle size={16} className="text-rose-500 mt-0.5 shrink-0" />
                  <span className="text-slate-700 text-sm lg:text-base leading-snug group-hover:text-red-700 transition-colors font-medium">
                    {alert.Name}
                  </span>
                  <ExternalLink size={14} className="text-slate-300 group-hover:text-red-400 shrink-0 mt-0.5 ml-auto transition-colors" />
                </motion.a>
              ))}
            </div>
          </div>

          {/* Image – scales gracefully on large displays */}
          <div className="flex items-center justify-center p-5 sm:p-6 lg:p-8 bg-slate-50">
            <img
              src={fraud}
              alt="Fraud Alert – Stay informed"
              width="300"
              height="250"
              loading="lazy"
              decoding="async"
              className="object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default FraudAlerts;